var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-forward-window" },
    [
      _vm.currentScreen === "agents"
        ? [
            _c(
              "a-tabs",
              { attrs: { tabPosition: "left" } },
              [
                _c(
                  "a-tab-pane",
                  {
                    key: "available-agents",
                    attrs: { tab: _vm.$t("message.toAvailableAgents") },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "search-input" },
                      [
                        _c("a-input-search", {
                          attrs: { placeholder: _vm.$t("message.searchAgent") },
                          on: { search: _vm.onSearch },
                          model: {
                            value: _vm.searchText,
                            callback: function ($$v) {
                              _vm.searchText = $$v
                            },
                            expression: "searchText",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.filteredAgents.length > 0
                      ? [
                          _c(
                            "SupsisTable",
                            _vm._b(
                              {
                                attrs: {
                                  columns: _vm.columns,
                                  rows: _vm.filteredAgents,
                                },
                              },
                              "SupsisTable",
                              _vm.tableOptions,
                              false
                            )
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "no-agents-placeholder" },
                            [
                              _c("a-icon", { attrs: { type: "frown" } }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.noAgentsAvailableToForward")
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.isOwneredContact
                  ? _c(
                      "a-tab-pane",
                      {
                        key: "available-departments",
                        attrs: {
                          tab: _vm.$t("message.toAvailableDepartments"),
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "search-input" },
                          [
                            _c("a-input-search", {
                              attrs: {
                                placeholder: _vm.$t("message.searchDepartment"),
                              },
                              on: { search: _vm.onDepartmentSearch },
                              model: {
                                value: _vm.departmentSearchText,
                                callback: function ($$v) {
                                  _vm.departmentSearchText = $$v
                                },
                                expression: "departmentSearchText",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "channel-visibility-info" }, [
                          _c("div", { staticClass: "info-box" }, [
                            _c("div", { staticClass: "info-content" }, [
                              _c(
                                "div",
                                { staticClass: "info-icon" },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "info-circle" },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "info-text" }, [
                                _c("div", { staticClass: "info-title" }, [
                                  _vm._v(
                                    "Kanal gizlilik ayarlarınızı kontrol ediniz"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "info-description d-flex align-items-center justify-content-between",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Göremediğiniz departmanlar var ise kanal gizlilik ayarlarını kontrol\n                                        ediniz"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "SupsisButton",
                                      {
                                        attrs: { ghost: "", type: "primary" },
                                        on: { click: _vm.goToChannelSettings },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Kanal ayarlarına git\n                                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.filteredDepartments.length > 0
                          ? [
                              _c(
                                "SupsisTable",
                                _vm._b(
                                  {
                                    attrs: {
                                      columns: _vm.departmentColumns,
                                      rows: _vm.filteredDepartments,
                                    },
                                  },
                                  "SupsisTable",
                                  _vm.tableOptions,
                                  false
                                )
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                { staticClass: "no-departments-placeholder" },
                                [
                                  _c("a-icon", { attrs: { type: "frown" } }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.noDepartmentsAvailableToForward"
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isOwneredContact
                  ? _c(
                      "a-tab-pane",
                      {
                        key: "both-agent-department",
                        attrs: {
                          tab: _vm.$t("message.toWithAgentAndDepartment"),
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "search-input" },
                          [
                            _c("a-input-search", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "message.searchAgentOrDepartment"
                                ),
                              },
                              on: { search: _vm.onGroupedSearch },
                              model: {
                                value: _vm.groupedSearchText,
                                callback: function ($$v) {
                                  _vm.groupedSearchText = $$v
                                },
                                expression: "groupedSearchText",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.filteredGroupedAgents.length > 0
                          ? _vm._l(
                              _vm.filteredGroupedAgents,
                              function (group, index) {
                                return _c(
                                  "div",
                                  { key: index },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "department-header",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleDepartment(
                                              group.departmentId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("a-icon", {
                                          attrs: {
                                            type: _vm.isDepartmentExpanded(
                                              group.departmentId
                                            )
                                              ? "minus-square"
                                              : "plus-square",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "h3",
                                          {
                                            style: {
                                              color: _vm.getDepartmentColor(
                                                group.departmentName
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(group.departmentName) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "SupsisTable",
                                      _vm._b(
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isDepartmentExpanded(
                                                group.departmentId
                                              ),
                                              expression:
                                                "isDepartmentExpanded(group.departmentId)",
                                            },
                                          ],
                                          attrs: {
                                            columns: _vm.groupedAgentColumns,
                                            rows: group.agents,
                                          },
                                        },
                                        "SupsisTable",
                                        _vm.tableOptions,
                                        false
                                      )
                                    ),
                                  ],
                                  1
                                )
                              }
                            )
                          : [
                              _c(
                                "div",
                                { staticClass: "no-agents-placeholder" },
                                [
                                  _c("a-icon", { attrs: { type: "frown" } }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.noAgentsAvailableToForward"
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                false && !_vm.isOwneredContact
                  ? _c(
                      "a-tab-pane",
                      {
                        key: "to-mobile-agents",
                        staticClass: "d-none",
                        attrs: { tab: _vm.$t("message.toMobileAgents") },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "search-input" },
                          [
                            _c("a-input-search", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "message.searchMobileAgent"
                                ),
                              },
                              on: { search: _vm.onMobileAgentSearch },
                              model: {
                                value: _vm.mobileAgentSearchText,
                                callback: function ($$v) {
                                  _vm.mobileAgentSearchText = $$v
                                },
                                expression: "mobileAgentSearchText",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.filteredMobileAgents.length > 0
                          ? [
                              _c(
                                "SupsisTable",
                                _vm._b(
                                  {
                                    attrs: {
                                      columns: _vm.columns,
                                      rows: _vm.filteredMobileAgents,
                                    },
                                  },
                                  "SupsisTable",
                                  _vm.tableOptions,
                                  false
                                )
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                { staticClass: "no-agents-placeholder" },
                                [
                                  _c("a-icon", { attrs: { type: "frown" } }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.noMobileAgentsAvailableToForward"
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                false && !_vm.isOwneredContact
                  ? _c(
                      "a-tab-pane",
                      {
                        key: "preferred-agents",
                        staticClass: "d-none",
                        attrs: { tab: _vm.$t("message.toPreferredAgents") },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "search-input" },
                          [
                            _c("a-input-search", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "message.searchPreferredAgent"
                                ),
                              },
                              on: { search: _vm.onPreferredAgentSearch },
                              model: {
                                value: _vm.preferredAgentSearchText,
                                callback: function ($$v) {
                                  _vm.preferredAgentSearchText = $$v
                                },
                                expression: "preferredAgentSearchText",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.filteredPreferredAgents.length > 0
                          ? [
                              _c(
                                "SupsisTable",
                                _vm._b(
                                  {
                                    attrs: {
                                      columns: _vm.columns,
                                      rows: _vm.filteredPreferredAgents,
                                    },
                                  },
                                  "SupsisTable",
                                  _vm.tableOptions,
                                  false
                                )
                              ),
                            ]
                          : [
                              _c(
                                "div",
                                { staticClass: "no-agents-placeholder" },
                                [
                                  _c("a-icon", { attrs: { type: "frown" } }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.noPreferredAgentsAvailableToForward"
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isOwneredContact
                  ? _c(
                      "a-tab-pane",
                      {
                        key: "to-queue",
                        attrs: { tab: _vm.$t("message.toQueue") },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column gap-2 justify-content-center align-items-center",
                          },
                          [
                            _c("div", { staticClass: "queue-info" }, [
                              _c("p", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.ifYouSendThisConversationToTheQueue"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.ifAutomaticChatAssignmentIsDisabled"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "queue-action" },
                              [
                                _c(
                                  "SupsisButton",
                                  {
                                    attrs: { ghost: "" },
                                    on: { click: _vm.forwardToQueue },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("message.sendQueue"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.currentScreen === "departments"
        ? [
            _c("ForwardDepartment", {
              attrs: {
                contact: _vm.contact,
                selectedUserId: _vm.selectedUserId,
                defaultSelectedDepartment: _vm.$_.get(
                  _vm.contact,
                  "lastConversation.subject"
                ),
                "default-change-owner-ship": _vm.changeOwnerShip,
              },
              on: {
                forward: _vm.onDepartmentSelected,
                back: function ($event) {
                  _vm.currentScreen = "agents"
                },
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }